import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

// import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { BaseInfoCardProps } from '..'
import { useIntl } from 'react-intl'
import { ArrowRight } from '@hhgtech/icons/other'
import { RichTextFormat } from 'components/atoms/richTextFormat'
import { useIsMobile } from 'hooks/useIsMobile'
// import { useHandlerUrls } from 'hooks/useHandlerUrls'

export type WideLayoutInfoCardProps = {
  icon?: string
} & BaseInfoCardProps &
  BoxProps

export const WideLayout = ({
  icon,
  title,
  description,
  thumbnail,
  url = '',
  styles,
  classNames,
  ...rest
}: WideLayoutInfoCardProps) => {
  const { formatMessage: f } = useIntl()
  // const isMobile = useIsMobile()
  const { classes, cx } = useStyles(undefined, {
    name: 'InfoCard--WideLayout',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  // const linkData = useHandlerUrls([url])
  // const { isExternalUrl } = linkData?.[0] || {}

  return (
    <Box
      className={classes.root}
      styles={styles}
      classNames={classNames}
      {...rest}
    >
      <div className={classes.container}>
        <Box className={classes.infoCol}>
          <Box className={classes.info}>
            {icon && (
              <Box className={classes.iconWrapper}>
                <img
                  src={icon}
                  alt={title}
                  loading="lazy"
                  className={classes.icon}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none'
                  }}
                />
              </Box>
            )}
            {title && <h2 className={classes.heading}>{title}</h2>}
            {description && (
              <Text size="p3" as="div">
                <RichTextFormat content={description} />
              </Text>
            )}
            {url && isMobile ? (
              <Box
                component="a"
                href={url}
                // target={isExternalUrl ? '_blank' : '_self'}
                target="_blank"
                className={cx(classes.ctaBtn, 'pointer-event-child-none')}
                data-event-category="App Install"
                data-event-action="Try Now Button"
                data-event-label={url}
              >
                <Button
                  className={classes.btn}
                  classNames={{
                    rightIcon: classes.btnIcon,
                  }}
                  variant="secondary"
                  rightIcon={<ArrowRight size={18} useCurrentColor />}
                >
                  {f({ id: 'common.tryNow', defaultMessage: 'Dùng thử ngay' })}
                </Button>
              </Box>
            ) : null}
          </Box>
        </Box>
        <Box className={classes.imgCol}>
          <div className={classes.boxFrame}>
            <Box className={classes.boxFrameInner}>
              <img
                src={thumbnail}
                className={classes.thumbnail}
                loading="lazy"
                alt={title}
              />
            </Box>
          </div>
        </Box>
      </div>
    </Box>
  )
}
